import {
  UPDATE_ENABLE_DISABLE_SERVICES,
  UPDATE_ENABLE_DISABLE_SERVICES_FAILURE,
  UPDATE_ENABLE_DISABLE_SERVICES_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateEnableDisableServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ENABLE_DISABLE_SERVICES:
      return { ...state, loading: true };
    case UPDATE_ENABLE_DISABLE_SERVICES_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_ENABLE_DISABLE_SERVICES_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateEnableDisableServicesReducer;
